/**
 * The open/closed eye toggle every "show more"/"hide" control in the app shares —
 * `TaskDrawer`, `GoneQuiet`, `StructureRow`, `QuickAddCard`, and `ClampedText`'s own expand
 * button.
 *
 * Its own file rather than living inside `TaskDrawer.tsx` (where it started): `ClampedText`
 * needs it too, and `TaskDrawer.tsx` imports `TaskList.tsx`, which imports `ClampedText.tsx`
 * — importing `EyeToggle` from `TaskDrawer.tsx` there would have closed that into a cycle.
 */

export function EyeToggle({
  open,
  onToggle,
  label,
}: {
  open: boolean;
  onToggle: () => void;
  /** What is being shown or hidden, e.g. "tasks in cinema". Reads after Show/Hide. */
  label: string;
}) {
  return (
    <button
      type="button"
      className="btn ghost small eye"
      onClick={onToggle}
      aria-expanded={open}
      aria-label={`${open ? "Hide" : "Show"} ${label}`}
      title={`${open ? "Hide" : "Show"} ${label}`}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        {open ? (
          <>
            <path
              d="M2 12s3.8-6 10-6 10 6 10 6-3.8 6-10 6-10-6-10-6z"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinejoin="round"
            />
            <circle cx="12" cy="12" r="2.6" fill="currentColor" />
          </>
        ) : (
          <>
            {/* Closed: the lid drawn as the lower arc, with lashes. */}
            <path
              d="M3 10c2.4 3.2 5.6 4.8 9 4.8S18.6 13.2 21 10"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinecap="round"
            />
            <path
              d="M5 13.4 3.6 15.6M12 14.9V17.4M19 13.4l1.4 2.2"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinecap="round"
            />
          </>
        )}
      </svg>
    </button>
  );
}
